export function fetchDealerInfo(apiUrl, accessToken, dealerNumber) {
    return fetch(`${apiUrl}/v1/dealerinfo/${dealerNumber}`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function fetchDealerList(apiUrl, accessToken) {
    return fetch(`${apiUrl}/v1/dealerinfo/list`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function fetchDealerDivisions(apiUrl, accessToken, dealerNumber) {
    return fetch(`${apiUrl}/v1/dealerinfo/${dealerNumber}/divisions`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
export function fetchB2BDomains(apiUrl, accessToken) {
    return fetch(`${apiUrl}/v1/dealerInfo/b2b-domains`, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });
}
